import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const toggle = o_util.toggle ?? {};
const get = toggle.get;
const getToggle = toggle.getToggle;
export {
  get,
  getToggle,
  toggle
};
/*                                      */
